import { render, staticRenderFns } from "./DigitalDownloadForm.vue?vue&type=template&id=f37a30ac"
import script from "./DigitalDownloadForm.vue?vue&type=script&lang=js"
export * from "./DigitalDownloadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports